import React from 'react';
import { Container, Typography, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { TextDecrypt } from '../content/TextDecrypt';
import { FirstName, LastName } from '../../utils/getName';
import profile from '../../assets/profile.webp';
import './About.css';

const useStyles = makeStyles((theme) => ({
  main: {
    width: '100%',
    padding: theme.spacing(4, 0),
  },
  aboutText: {
    marginBottom: theme.spacing(2),
    lineHeight: 1.6,
  },
  profileImg: {
    width: '100%',
    maxWidth: 400,
    height: 'auto',
    aspectRatio: '1.75',
    borderRadius: 16,
    boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
    border: '1px solid rgba(255, 255, 255, 0.51)',
    flexShrink: 0,
  },
  contentWrapper: {
    flex: 1,
    minWidth: 0,
  },
  contactButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.5rem',
    marginTop: '1rem',
    marginRight:'1rem',
    padding: '0.5rem 1rem',
    textDecoration: 'none',
    color: '#00ff00',
    borderRadius: '4px',
    transition: 'all 0.3s ease',
  },
}));

export const About = () => {
  const classes = useStyles();
  const greetings = 'Hello World!';
  const aboutme = `I'm ${FirstName} ${LastName}, a web developer and cloud enthusiast with a passion for leveraging technology to solve real-world challenges. I have a solid understanding of development and deployment processes and am constantly exploring new technologies to stay ahead in the field, with the goal of contributing meaningfully to creating solutions that improve the world.`;

  return (
    <section id="about">
      <Container component="main" className={classes.main} maxWidth={false}>
        <div className="about">
          {/* Profile Image */}
          <img src={profile} alt="Profile" className="_img" />
          
          {/* Content Section */}
          <div className={classes.contentWrapper}>
            <Typography component="h2" variant="h4" gutterBottom>
              <TextDecrypt text={greetings} />
            </Typography>
            
            <Typography variant="body1" className={classes.aboutText}>
              {aboutme}
            </Typography>
            
            <Button 
              onClick={() => window.dispatchEvent(new CustomEvent('show-contact'))}
              className={classes.contactButton}
              variant="outlined"
            >
              <i className="fas fa-terminal" />
              <Typography component="span"> Send me a message.</Typography>
            </Button>
            <Button
              href="https://calendly.com/jobinabraham"
              className={classes.contactButton}
              variant="outlined">
            <i className="fas fa-calendar-check" />
            <Typography component="span"> Schedule a Meeting</Typography>
            </Button>
          </div>
        </div>
      </Container>
    </section>
  );
};
